import React, { useEffect, useState} from 'react';
import ProjectCart from './ProjectCart';
import './ProjectDetails.css';
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import FrontEndProjCart from './FrontEndProjCart';

export default function ProjectDetails(props) {
    let fadeInScreenHandler = (screen) => {
      if (screen.fadeInScreen !== props.id) return;
      Animations.animations.fadeInScreen(props.id);
    };
    const fadeInSubscription =
      ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);
  

 const [projects,setProjects] =useState([]);
 const [FrontProjects,setFrontProjects]=useState([]);

 useEffect(()=>{
    fetch('https://merajul-hasan-portfolio-server.vercel.app/AllProjects')
      .then(res=>res.json())
      .then(data=>setProjects(data))
},[])
useEffect(()=>{
  fetch('https://merajul-hasan-portfolio-server.vercel.app/FrontEndProj')
    .then(res=>res.json())
    .then(data=>setFrontProjects(data))
},[])
    return (

        <div
           className="about-me-container screen-container fade-in"
           id={props.id || ""}
        >
       
        <div>
            <ScreenHeading
                title={"ProjectDetails"}
                subHeading={"See All My Projects"}
            />
          <p className='proj_sec'>Below All The MERN Stack Projects (Front end and Back end).</p> 
          <div className='Project_Container'>
           
            {
               projects.map(project=><ProjectCart
                key={project._id}
                project={project}
               >
               </ProjectCart>)  
            }
          </div>
          <p className='proj_sec'>Below All The Front end Projects.</p> 
          <div className='Project_Container'>
            {
              FrontProjects.map(FrontProject=><FrontEndProjCart
                key={FrontProject._id}
                FrontProject={FrontProject}
              ></FrontEndProjCart>)  
            }
          </div>
           
          
          
        </div>
       
        </div>
    );
        
}


